import { TextareaProps } from './index'

const basic: TextareaProps = {
  name: 'firstName',
  placeholder: 'Placeholder',
  label: 'Label',
}

const required: TextareaProps = {
  ...basic,
  required: true,
}

const error: TextareaProps = {
  ...basic,
  error: 'error',
}

const errorHidden: TextareaProps = {
  ...basic,
  showError: false,
  error: 'error',
}

const disabled: TextareaProps = {
  ...basic,
  disabled: true,
  value: 'value',
}

const helperTextStart: TextareaProps = {
  ...basic,
  helperText: 'Helper on left',
  helperTextSide: 'start',
}

const helperTextEnd: TextareaProps = {
  ...basic,
  helperText: 'Helper on right',
  helperTextSide: 'end',
}

export const textareaMocks = {
  basic,
  required,
  error,
  errorHidden,
  disabled,
  helperTextStart,
  helperTextEnd,
}
